import React from "react";
import C3Chart from "react-c3js";
import clientService from "../../../services/client";
import ChartDateRangeForm from "./ChartDateRangeForm";
import AnalyticsChartCard from "./AnalyticsChartCard";
import { defaultStartDate, rotatedBarAxis } from "./chartUtils";

const emptyChart = {
  columns: [["x", null], ["Idle", null], ["Occupied", null]],
  colors: {
    Idle: "#662C8F",
    Occupied: "#0A49B6",
  },
  type: "bar",
  x: "x",
};

export default class IdleAndOccupancyChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: defaultStartDate(),
      endDate: new Date(),
      chartData: emptyChart,
    };
  }

  componentDidMount() {
    this.fetchData(this.state.startDate, this.state.endDate);
  }

  async fetchData(startDate, endDate) {
    let rows = [];
    try {
      const { data: res } = await clientService.idleAndOccupancyGraph(
        startDate,
        endDate,
        [],
      );
      if (res) {
        rows = res.result || [];
      }
    } catch (err) {
      console.error(err);
    }

    this.setState({
      chartData: {
        ...emptyChart,
        columns: [
          ["x", ...rows.map((m) => m.name)],
          ["Idle", ...rows.map((m) => m.idleTime)],
          ["Occupied", ...rows.map((m) => m.totalAgentChatTime)],
        ],
      },
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.fetchData(this.state.startDate, this.state.endDate);
  };

  render() {
    return (
      <React.Fragment>
        <ChartDateRangeForm
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onStartChange={(date) => this.setState({ startDate: date })}
          onEndChange={(date) => this.setState({ endDate: date })}
          onSubmit={this.handleSubmit}
          layout="inline"
        />
        <div className="col col-12 col-sm-12 col-lg-12" />
        <AnalyticsChartCard
          title="Idle And Occupancy"
          cardClassName="box-3rd card card101"
          wrapCol={false}
        >
          <C3Chart
            size={{ height: 500 }}
            bar={{ width: 50 }}
            padding={{ left: 100 }}
            data={this.state.chartData}
            axis={rotatedBarAxis}
            legend={{ show: true }}
          />
        </AnalyticsChartCard>
      </React.Fragment>
    );
  }
}
